export const mockOfficeAgent = {
    name: 'office',
    display_name: 'Office Assistant',
    color: '#4A90D9',
    icon: 'fa-light fa-lamp-desk',
    short_description: 'Navigate & Act'
};
export const mockDataAgent = {
    name: 'data',
    display_name: 'Data Assistant',
    color: '#7B68EE',
    icon: 'fa-light fa-chart-sine',
    short_description: 'Export & Analyze'
};
export const mockCodeAgent = {
    name: 'code',
    display_name: 'Fire Code Expert',
    color: '#2ECC71',
    icon: 'fa-light fa-square-c',
    short_description: 'NFPA Lookups'
};
export const mockAgents = [mockOfficeAgent, mockDataAgent, mockCodeAgent];
export const mockFieldAgent = {
    name: 'field',
    display_name: 'Field Assistant',
    color: '#585870',
    icon: 'fa-light fa-helmet-safety',
    short_description: 'Your day in the field'
};
